<template>
  <div class="modal">
    <TitleFrame text="施設詳細" :show-return="true" @click-close="onClickClose">
      <template slot="contents">
        <div class="content-area" id="modal-all-content-area">
          <div v-if="false">
            <p>この場所までの距離{{ distance }}</p>
            <p>この場所の緯度: {{ targetLat }}</p>
            <p>この場所の経度: {{ targetLng }}</p>
            <p>registrationId: {{ registrationId }}</p>
            <p>selectedSpot.id: {{ selectedSpot.id }}</p>
            <p>selectedSpotDocId: {{ selectedSpot.docId }}</p>
          </div>
          <TitleArea :selectedSpot="selectedSpot" :comments="comments" />
          <CheckInArea :selectedSpot="selectedSpot" :distance="distance" />
          <div class="modal-content-area">
            <ImageArea
              v-if="selectedSpot.spot_images !== 0"
              :selectedSpot="selectedSpot"
            />
            <PhotoMissionArea
              v-if="selectedSpotPhotoMission.length !== 0"
              :missonList="selectedSpotPhotoMission"
              :distance="distance"
              :current="current"
            />
            <QuizMissionArea
              v-if="selectedSpotQuizMission.length !== 0"
              :missonList="selectedSpotQuizMission"
              :distance="distance"
              :current="current"
            />
            <TicketArea
              v-if="selectedSpot.tickets && selectedSpot.tickets.length !== 0"
              :ticketList="selectedSpot.tickets"
              :distance="distance"
              :current="current"
            />
            <SpotInfo :spot-data="selectedSpot" />
            <ReviewAreaRoot :comments="comments" />
            <ButtonTextLink
              class="gotohere"
              text="ここに立ち寄る"
              @click-text="onClickGo"
            />
          </div>
        </div>
      </template>
    </TitleFrame>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import TitleAndText from "@/components/Atoms/TitleAndText";
import TitleFrame from "@/components/Templates/TitleFrame";
import TextLink from "@/components/Atoms/TextLink";
import Firebase from "./../../firebase";
import InputPhoto from "@/components/Missions/InputPhoto";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import ReviewAreaRoot from "@/components/DropSpotSelectModal/ReviewAreaRoot";
import SpotInfo from "@/components/DropSpotSelectModal/SpotInfo";
import TitleArea from "@/components/DropSpotSelectModal/TitleArea";
import PhotoMissionArea from "@/components/DropSpotSelectModal/PhotoMissionArea";
import QuizMissionArea from "@/components/DropSpotSelectModal/QuizMissionArea";
import CheckInArea from "@/components/DropSpotSelectModal/CheckInArea";
import TicketArea from "@/components/DropSpotSelectModal/TicketArea";
import ImageArea from "@/components/DropSpotSelectModal/ImageArea";
import DropTimeSelectDialog from "@/components/DropSpotSelect/DropTimeSelectDialog";
import axios from "axios";

export default {
  name: "drop-spot-select-modal",
  components: {
    TitleAndText,
    TitleFrame,
    TextLink,
    InputPhoto,
    ButtonTextLink,
    ReviewAreaRoot,
    SpotInfo,
    TitleArea,
    PhotoMissionArea,
    QuizMissionArea,
    CheckInArea,
    TicketArea,
    ImageArea,
    DropTimeSelectDialog,
  },
  props: {
    current: { type: String, default: false, required: true },
  },
  computed: {
    ...mapState([
      "registrationId",
      "currentLat",
      "currentLng",
      "missions",
      "checkinList",
      "selectedSpotData",
      "selectedSpotCommentData",
      "selectedSpotTicketData",
      "search",
      "DepLatLng",
      "DesLatLng",
    ]),
    currentSearch() {
      if (this.current === "RouteSearch") {
        return this.search.dropspot;
      } else if (this.current === "JyutaiSearch") {
        return this.search.jyutai;
      }
    },
    currentDepLatLng() {
      if (this.current === "RouteSearch") {
        return this.DepLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DepLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DepLatLng.jyutai;
      }
      return "test";
    },
    currentDesLatLng() {
      if (this.current === "RouteSearch") {
        return this.DesLatLng.dropspot;
      } else if (this.current === "MyPage") {
        return this.DesLatLng.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.DesLatLng.jyutai;
      }
      return "test";
    },
    selectedSpot() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotData.dropspot;
      } else if (this.current === "MyPage") {
        return this.selectedSpotData.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotData.jyutai;
      }
    },
    comments() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotCommentData.dropspot;
      } else if (this.current === "MyPage") {
        return this.selectedSpotCommentData.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotCommentData.jyutai;
      }
    },
    selectedSpotCategory() {
      if (this.selectedSpot.category.id === 1) return "観光";
      else if (this.selectedSpot.category.id === 2) return "温泉";
      else if (this.selectedSpot.category.id === 3) return "食事";
      else if (this.selectedSpot.category.id === 4) return "体験";
      else if (this.selectedSpot.category.id === 5) return "お土産";
      return "";
    },
    isCheckedIn() {
      return this.isCheckedInList.length !== 0;
    },
    currentDate() {
      const targetDate = new Date();
      const dateString = `${targetDate.getFullYear()}/${
        targetDate.getMonth() + 1
      }/${targetDate.getDate()}`;
      return dateString;
    },
    isCheckedInList() {
      return this.checkinList.filter((x) => this.selectedSpot.id === x.spot_id);
    },
    targetLat() {
      return this.selectedSpot.lat;
    },
    targetLng() {
      return this.selectedSpot.lon;
    },
    distance() {
      const R = Math.PI / 180;
      let tmpLat = this.targetLat;
      let tmpLng = this.targetLng;
      let currentLat = this.currentLat;
      let currentLng = this.currentLng;
      currentLat *= R;
      currentLng *= R;
      tmpLat *= R;
      tmpLng *= R;
      return (
        6371 *
        Math.acos(
          Math.cos(currentLat) *
            Math.cos(tmpLat) *
            Math.cos(tmpLng - currentLng) +
            Math.sin(currentLat) * Math.sin(tmpLat),
        ) *
        1000
      );
    },
    selectedSpotPhotoMission() {
      if (this.selectedSpot.missions) {
        return this.selectedSpot.missions.filter(
          (missoon) => missoon.mission_type === 20,
        );
      }
      return [];
    },
    selectedSpotQuizMission() {
      if (this.selectedSpot.missions) {
        return this.selectedSpot.missions.filter(
          (missoon) => missoon.mission_type === 30,
        );
      }
      return [];
    },
  },
  data() {
    return {
      isOpenSelectTimeDialog: false,
    };
  },
  methods: {
    ...mapMutations([
      "setDropDestionaton",
      "loadingStartMini",
      "loadingEndMini",
      "setSearchState",
      "setSelectedSpotData",
      "setSearch",
      "setDepLatLng",
      "setDesLatLng",
    ]),
    onClickClose() {
      this.$emit("click-close");
    },
    mappingType(id) {
      if (id === 1) return "camera";
      else if (id === 2) return "spa";
      else if (id === 3) return "restaurant";
      else if (id === 4) return "experience";
      else if (id === 5) return "shopping";
    },
    async onClickGo() {
      // ログ用の処理ここから
      let rating = null;
      if (this.comments && this.comments.length !== 0) {
        const numbers = this.comments.map((comment) => comment.Reputation);
        const sum = numbers.reduce((x, y) => x + y);
        rating = sum / numbers.length;
      }
      const actionParams = {
        name: this.selectedSpot.name,
        lat: this.selectedSpot.lat,
        lon: this.selectedSpot.lon,
        opening_hours: this.selectedSpot.business_hours,
        category: this.mappingType(this.selectedSpot.category.id),
        rating: rating,
        congestion:
          this.selectedSpot.reports.length === 0
            ? "不明"
            : this.selectedSpot.reports[0].congestion,
      };

      Firebase.putLog({
        ActionType: "ChooseSpot",
        ActionParams: actionParams,
      });
      // ログ用の処理ここまで
      const latlng = new window.google.maps.LatLng(
        this.selectedSpot.lat,
        this.selectedSpot.lon,
      );
      this.setDropDestionaton({
        latlng: latlng,
        name: this.selectedSpot.name,
        stayTime: 60 * 60,              // default
      });

      if (this.current === "MyPage") {
        const now = new Date();
        this.setSearch({
          departure: "現在地",
          destination: "現在地",
          departureTime: now,
        });
        await this.getGeo("現在地", true);
        await this.getGeo("現在地", false);
      }

      this.isOpenSelectTimeDialog = false;
      this.setSearchState("result");
    },
    async getGeo(text, dep) {
      const re = new RegExp("^[0-9]{1,3}.[0-9]*.* [0-9]{1,3}.[0-9]*");
      if (re.test(text)) {
        const coord = new RegExp("([0-9]{1,3}.[0-9]*)", "g");
        let parsedString = text.match(coord);
        let latlng = new window.google.maps.LatLng(
          parsedString[0],
          parsedString[1],
        );
        if (dep) {
          this.setDepLatLng(latlng);
        } else {
          this.setDesLatLng(latlng);
        }
        return;
      }
      if (text === "現在地") {
        let latlng = new window.google.maps.LatLng(
          this.currentLat,
          this.currentLng,
        );
        if (dep) {
          this.setDepLatLng(latlng);
        } else {
          this.setDesLatLng(latlng);
        }
        return;
      }
      const setDepLatLng = this.setDepLatLng;
      const setDesLatLng = this.setDesLatLng;
      const geocoder = new window.google.maps.Geocoder();
      const loadingEndMini = this.loadingEndMini;
      await geocoder.geocode(
        {
          address: text,
        },
        function (results, status) {
          if (status === window.google.maps.GeocoderStatus.OK) {
            for (var i in results) {
              if (results[0].geometry) {
                var latlng = results[0].geometry.location;
                if (dep) {
                  setDepLatLng(latlng);
                } else {
                  setDesLatLng(latlng);
                }
              }
            }
          } else if (
            status === window.google.maps.GeocoderStatus.ZERO_RESULTS
          ) {
            let tex = "目的地";
            if (dep) {
              tex = "出発地";
            }
            alert(tex + "が見つかりませんでした");
          } else {
            alert("GooleMapで場所情報取得中にエラーが発生しました");
          }
          loadingEndMini();
        },
      );
    },
  },
  async mounted() {
    this.loadingStartMini();

    this.miniLoading = true;

    let param = {
      api_key: "i73rauGTyfewa",
      lat: this.currentLat,
      lng: this.currentLng,
      registration_id: this.registrationId,
    };

    await Firebase.getSpot(this.current);
    await axios
      .get(
        `https://mission-kqxgrnovcq-uc.a.run.app/api/spots/${this.selectedSpot.id}`,
        { params: param },
      )
      .then((response) => {
        if (response.data[0].id === null) throw e;
        this.setSelectedSpotData({
          ...this.selectedSpot,
          ...response.data[0],
        });
      })
      .catch(() => {
        window.alert("エラーが発生しました。時間をあけて再度お試しください");
        this.onClickClose();
      });
    this.miniLoading = false;
    this.loadingEndMini();
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.content-area {
  position: fixed;
  height: 100%;
  overflow: scroll;
  background: white;
}
.modal {
  background-color: white;
  z-index: 1;
  position: fixed;
  width: 100%;
  height: 100%;
}

.buttonArea {
  .so-far-text {
    text-align: center;
    color: rgb(177, 24, 24);
  }
  &.isClicked {
    background: #5cd5d6;
  }
  .buttonMainArea {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  margin-top: 8px;
  border-radius: 4px;
  border: 1px solid #5cd5d6;
  .buttonAreaImg {
    width: 25px;
    height: 25px;
    margin: auto 0;
    margin-right: 8px;
  }
  .checkedInText {
    color: #fff;
    font-weight: bold;
    font-size: 1.1rem;
  }
}

.gotohere {
  width: calc(100% - 1.25rem * 2) !important;
  position: fixed;
  left: 1.25rem;
  bottom: 3rem;
}

.modal-content-area {
  padding-bottom: 8rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/DropSpotSelectModal.vue